import {Actions, StateChanges} from './stateChanges'
import axios from 'axios'


const SEARCH_API = 'https://top-phrase-0-1.loadbalancer2.dicta.org.il/top_phrases'
//const proxyurl = "https://cors-anywhere.herokuapp.com/";
//const GRAPH_API = '"https://9qwvyn65ac.execute-api.us-east-1.amazonaws.com/dev/test/'

const axiosInstance = axios.create({timeout: 300000})
var source

export default {
  [Actions.RUN_SEARCH]: function ({ commit, state }) {   
    let textForApi = state.textForApiCall
    let mode = state.mode
    let wordsNum = state.wordsNum
    if (textForApi !== '' && !state.invalidTerm) {
      commit(StateChanges.SEARCH_RUNNING)      
      window.history.replaceState( {} , '', '?search='+textForApi+'&mode='+mode+'&num_words='+wordsNum )      
      if(source){
        source.cancel();
     }
     const CancelToken = axios.CancelToken;
     source = CancelToken.source();
     axiosInstance
     .get(SEARCH_API + '/' + mode +'/'+ wordsNum +'/'+ encodeURIComponent(textForApi),{
       cancelToken: source.token       
      }).then(function (response) {        
        commit(StateChanges.SET_SEARCH_RESULTS, response.data)
        commit(StateChanges.SEARCH_COMPLETE)
       }).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          //console.log('Request cancelled');
        } else {          
          commit(StateChanges.SEARCH_FAILED)
        }
      })
     } else {
        //window.history.replaceState( {} , '', location.href.split("?")[0] )
     }
    }
  }
